import { applyCellStyle } from '../utils/excel-helpers.js';
import { getAggregationValueById } from '../data/aggregation.js';
import { EXCEL_STYLES } from '../constants.js';

export const createWBSCell = (row, task, column, currentDataCol, fieldHandlers, isParent) => {
  const cell = row.getCell(currentDataCol);
  const handler = fieldHandlers[column.type] || fieldHandlers.default;
  const value = task.data?.[column.key] || '';
  const result = handler(value, column);
  
  cell.value = result.value || '';
  if (result.style) applyCellStyle(cell, result.style);
  if (isParent) cell.font = { ...cell.font, bold: true };
  cell.alignment = { horizontal: 'left', vertical: 'middle' };
  
  return { cell, result, nextCol: currentDataCol + 1 };
};

export const createDataCell = (row, task, column, currentDataCol, taskId, taskType, isParent, aggregationData, fieldHandlers, options, worksheet) => {
  const cell = row.getCell(currentDataCol);
  const columnKey = column.key;
  
  const aggregationValue = isParent && options.includeAggregation ? 
    getAggregationValueById(task.data?.id, columnKey, aggregationData) : null;
  
  const aggregationItem = options.includeAggregation ? 
    aggregationData.find(item => item.idColumn === columnKey && item.id == taskId) : null;
  
  
  if (column.key === 'type' || column.type === 'type') {
    cell.value = '';
    const typeStyle = fieldHandlers.type(taskType, isParent);
    if (typeStyle.style) applyCellStyle(cell, typeStyle.style);
    cell.alignment = { horizontal: 'center', vertical: 'middle' };
    return { cell, result: null, nextCol: currentDataCol + 1 };
  }
  
  let result = null;
  
  if ((aggregationItem || aggregationValue !== null) && column.type === 'aggregation') {
    const handler = fieldHandlers[column.type] || fieldHandlers.default;
    const valueToUse = isParent ? aggregationValue : (aggregationItem?.value || '');
    result = handler(valueToUse, column, isParent);
    
    cell.value = result.value || '';
    if (result.style) applyCellStyle(cell, result.style);
    if (isParent) cell.font = { ...cell.font, bold: true };
    cell.alignment = { horizontal: 'center', vertical: 'middle' };
  } else {
    const handler = fieldHandlers[column.type] || fieldHandlers.default;
    const value = task.data?.[column.key] || '';
    result = handler(value, column);
    
    cell.value = result.value || '';
    if (result.style) applyCellStyle(cell, result.style);
    if (isParent) cell.font = { ...cell.font, bold: true };
    
    if (column.type === 'date' || column.type === 'number') {
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
    } else {
      cell.alignment = { horizontal: 'left', vertical: 'middle' };
    }
  }
  
  if (result && result.colWidth && !worksheet.getColumn(currentDataCol).width) {
    worksheet.getColumn(currentDataCol).width = result.colWidth;
  }
  
  return { cell, result, nextCol: currentDataCol + 1 };
};

export const createFlatDataCell = (row, task, column, colIndex, taskId, taskType, aggregationData, fieldHandlers, options, worksheet) => {
  const cell = row.getCell(colIndex + 1);
  const columnKey = column.key;
  
  const aggregationItem = options.includeAggregation ? 
    aggregationData.find(item => item.idColumn === columnKey && item.id == taskId) : null;
  
  
  if (column.key === 'type' || column.type === 'type') {
    cell.value = '';
    const typeStyle = fieldHandlers.type(taskType, false);
    if (typeStyle.style) applyCellStyle(cell, typeStyle.style);
    return { cell, result: null };
  }
  
  let result = null;
  
  if (aggregationItem && column.type === 'aggregation') {
    const handler = fieldHandlers[column.type] || fieldHandlers.default;
    result = handler(aggregationItem.value, column);
    
    cell.value = result.value || '';
    if (result.style) applyCellStyle(cell, result.style);
  } else {
    const handler = fieldHandlers[column.type] || fieldHandlers.default;
    const value = task.data?.[column.key] || '';
    result = handler(value, column);
    
    cell.value = result.value || '';
    if (result.style) applyCellStyle(cell, result.style);
  }
  
  if (result && result.colWidth && !worksheet.getColumn(colIndex + 1).width) {
    worksheet.getColumn(colIndex + 1).width = result.colWidth;
  }
  
  return { cell, result };
};

export const createWBSNameCell = (worksheet, row, task, taskNameStartCol, level, maxNestingLevel, isParent) => {
  const indentStartCol = taskNameStartCol;
  
  if (level === 0) {
    const mergeStartCol = indentStartCol;
    const mergeEndCol = indentStartCol + maxNestingLevel;
    
    if (mergeEndCol > mergeStartCol) {
      worksheet.mergeCells(row.number, mergeStartCol, row.number, mergeEndCol);
    }
    
    const mergedCell = row.getCell(mergeStartCol);
    mergedCell.value = task.data?.name || '';
    mergedCell.alignment = { horizontal: 'left', vertical: 'middle' };
    
    if (isParent) {
      mergedCell.font = { bold: true, color: { argb: EXCEL_STYLES.BLACK_TEXT } };
    }
    
    return indentStartCol + maxNestingLevel + 1;
  } else {
    for (let i = 0; i < level; i++) {
      const emptyCell = row.getCell(indentStartCol + i);
      emptyCell.value = '';
    }
    
    const mergeStartCol = indentStartCol + level;
    const mergeEndCol = indentStartCol + maxNestingLevel;
    
    if (mergeEndCol > mergeStartCol) {
      worksheet.mergeCells(row.number, mergeStartCol, row.number, mergeEndCol);
    }
    
    const mergedCell = row.getCell(mergeStartCol);
    mergedCell.value = task.data?.name || '';
    mergedCell.alignment = { horizontal: 'left', vertical: 'middle' };
    
    if (isParent) {
      mergedCell.font = { bold: true, color: { argb: EXCEL_STYLES.BLACK_TEXT } };
    }
    
    return indentStartCol + maxNestingLevel + 1;
  }
};